import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
} from '@mui/material';
import Button from '@components/atoms/Button/Button.jsx';
import './styles/styles.scss';
import ClearIcon from '@mui/icons-material/Clear';
import PropTypes from 'prop-types';

let modalRoot = null;

const getOrCreateModalRoot = () => {
  if (modalRoot && modalRoot._internalRoot !== null) return modalRoot;

  const modalRootEl = document.createElement('div');
  modalRootEl.className = 'modal-root';
  modalRoot = ReactDOM.createRoot(modalRootEl);
  return modalRoot;
};

const OpenOnceModal = ({
  message,
  html,
  title,
  okText,
  cancelText,
  onCancel,
  onOk,
  closeButton,
  onHide,
  className,
  titleClassName,
  onUnmount,
  widthCancelBtn,
  widthOkBtn,
  disableClose,
  onOkWithEnter,
  maxWidth = 'sm',
}) => {
  const handleClickCloseIcon = () => {
    onUnmount();
    if (onHide) onHide();
  };
  const handleClickCancelBtn = () => {
    onUnmount();
    if (onCancel) onCancel();
  };
  const handleClickOkBtn = () => {
    onUnmount();
    if (onOk) onOk();
  };

  useEffect(() => {
    if (onOkWithEnter) {
      const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          handleClickOkBtn();
        }
      };

      document.addEventListener('keydown', handleKeyDown);

      return () => {
        document.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, [onOkWithEnter]);

  return (
    <Dialog open={true} maxWidth={maxWidth} className="global-modal" fullWidth>
      <Box className={className}>
        <Box className="global-modal-header">
          <Typography variant="h4" sx={{ p: '0.5rem' }}>
            {title}
          </Typography>
          {!disableClose && (
            <IconButton onClick={handleClickCloseIcon} className="icon-button">
              {closeButton || <ClearIcon />}
            </IconButton>
          )}
        </Box>

        <DialogContent className="global-modal-content">
          {message || <div dangerouslySetInnerHTML={{ __html: html || '' }} />}
        </DialogContent>
        <Box className="global-modal-footer">
          {onCancel && (
            <Button
              className="global-modal-cancelBtn"
              type="submit"
              variant="contained"
              fontWeight="700"
              fontSize="1rem"
              onClick={handleClickCancelBtn}
              sx={{ marginRight: '1rem', width: widthCancelBtn }}
            >
              {cancelText || 'Cancel'}
            </Button>
          )}
          {onOk && (
            <Button
              className="global-modal-okBtn"
              type="submit"
              variant="contained"
              fontWeight="700"
              fontSize="1rem"
              onClick={handleClickOkBtn}
              sx={{ width: widthOkBtn }}
            >
              {okText || 'OK'}
            </Button>
          )}
        </Box>
      </Box>
    </Dialog>
  );
};

OpenOnceModal.propTypes = {
  message: PropTypes.string,
  html: PropTypes.string,
  title: PropTypes.string.isRequired,
  okText: PropTypes.string,
  cancelText: PropTypes.string,
  onCancel: PropTypes.func,
  onOk: PropTypes.func,
  closeButton: PropTypes.element,
  onHide: PropTypes.func,
  className: PropTypes.string,
  titleClassName: PropTypes.string,
  onUnmount: PropTypes.func,
  disableClose: PropTypes.bool,
  onOkWithEnter: PropTypes.bool,
  maxWidth: PropTypes.string,
};

export const GlobalModal = {
  openOnce: (props) => {
    const root = getOrCreateModalRoot();
    return root.render(
      <OpenOnceModal onUnmount={() => root.unmount()} {...props} />,
    );
  },
};
